export default {
  add: 'SHOPPINGCARTITEM_MUTATIONS_ADD',
  edit: 'SHOPPINGCARTITEM_MUTATIONS_EDIT',
  delete: 'SHOPPINGCARTITEM_MUTATIONS_DELETE',
  deleteAll: 'SHOPPINGCARTITEM_MUTATIONS_DELETE_ALL',
  syncing: 'SHOPPINGCARTITEMS_MUTATIONS_SYNCING'
}
